import type { PlanConflict, PlanBedDeletionConflict, PlanCoordinateConflict } from '../types/plan';

/**
 * Type guard to check if conflict is a bed deletion conflict
 * (bed has active plantings and cannot be deleted)
 */
export const isBedDeletionConflict = (conflict: PlanConflict): conflict is PlanBedDeletionConflict => {
  return 'bedId' in conflict && 'activePlantings' in conflict;
};

/**
 * Type guard to check if conflict is a coordinate conflict
 * (cell already occupied during createBed operation)
 */
export const isCoordinateConflict = (conflict: PlanConflict): conflict is PlanCoordinateConflict => {
  return (
    'rowWorld' in conflict ||
    'colWorld' in conflict ||
    'row_world' in conflict ||
    'col_world' in conflict
  );
};
